import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { toDisplayString as _toDisplayString } from "vue";
export default {
  __name: 'AppTextCounter',
  props: /*@__PURE__*/_mergeModels({
    maxlength: {
      type: Number,
      "default": 1000
    }
  }, {
    "modelValue": {
      type: String
    },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup: function setup(__props) {
    var textInput = _useModel(__props, "modelValue");
    return function (_ctx, _cache) {
      return _toDisplayString(textInput.value.length) + " / " + _toDisplayString(__props.maxlength);
    };
  }
};